module.exports = window["wp"]["domReady"];